var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510.625 510.625",
    style: {
      enableBackground: "new 0 0 510.625 510.625"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 0 45)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DECE"
    },
    d: "M216.2-31.929c10.57,22.71,2.412,48.902-18.227,58.516s-54.272,0.876-59.608-23.586 c-5.291-24.303-0.33-61.315,21.356-60.302c5.996,0.284,12.038,0.762,17.886,1.695c0.762-2.856,0.592-8.67-0.489-14.188 c-4.198-21.208,24.701-31.289,28.877-10.047c2.435,12.436-2.207,22.084-4.244,31.141C207.633-44.785,212.673-39.495,216.2-31.929 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292F33"
    },
    d: "M221.582,16.541c-13.073,17.34-32.028,25.361-65.991,14.552 c-29.662-9.432-20.332-34.987-14.746-29.503c8.897,8.727,19.991,5.211,19.991,5.211l7.191-26.34c0,0,4.016-2.753,6.281,5.916 c2.276,8.67,14.097,8.852,17.533,1.559c5.336-11.321-2.651-12.948-3.766-19.467c-3.516-20.594,19.49-21.197,19.49-21.197 s4.358-2.037,12.925,12.55C229.046-25.591,234.564-0.674,221.582,16.541"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC2AD"
    },
    d: "M251.801-202.823c-6.292,0-11.378,5.086-11.378,11.378c0,51.428-53.032,105.21-53.567,105.745 c-4.426,4.449-4.426,11.651,0.023,16.088c4.449,4.437,11.639,4.426,16.077,0c2.458-2.469,60.223-60.939,60.223-121.833 C263.179-197.737,258.093-202.823,251.801-202.823"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A6797"
    },
    d: "M160.779-362.112c-12.572,0-22.756,10.194-22.756,22.756v79.644c0,3.959,1.035,7.851,3.004,11.287 l45.511,79.644c6.224,10.911,20.139,14.723,31.039,8.465c10.911-6.224,14.7-20.127,8.465-31.039l-42.507-74.399v-73.603 C183.535-351.917,173.34-362.112,160.779-362.112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4289C1"
    },
    d: "M263.19-327.978c-6.679,0-13.289,2.924-17.772,8.545l-45.511,56.889 c-2.287,2.833-3.834,6.178-4.551,9.739l-11.378,56.889c-2.469,12.322,5.518,24.326,17.84,26.783 c12.379,2.492,24.326-5.53,26.783-17.84l10.297-51.473l42.052-52.565c7.851-9.808,6.258-24.132-3.561-31.983 C273.203-326.34,268.185-327.978,263.19-327.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B255"
    },
    d: "M240.424-180.067c0,0,0-11.378-22.756-11.378h-45.511 c-22.756,68.267-4.085,136.533,22.756,136.533c34.133,0,34.133-45.511,45.511-102.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DECE"
    },
    d: "M183.535-100.423c-0.011-0.512-0.751-51.792-40.96-81.954l0.114-0.159 c-2.765-2.071-4.665-5.222-4.665-8.943c0-6.292,5.097-11.378,11.378-11.378c2.56,0,4.813,1.001,6.713,2.435l0.114-0.159 c49.493,37.126,50.062,97.576,50.062,100.124L183.535-100.423z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292F33"
    },
    d: "M299.383-317.26c3.083,3.083,1.82,7.691-1.468,10.695c-5.268,4.813-7.657,6.531-7.657,6.531 c-2.901,1.911-9.933,4.745-12.857,1.832c-21.311-21.22-37.592-51.553-38.184-62.123c-0.353-6.235,7.339-9.728,11.708-5.359 C263.816-352.793,288.21-328.422,299.383-317.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292F33"
    },
    d: "M182.579-372.5c4.358-0.034,6.758,4.107,6.576,8.567c-0.273,7.122-0.728,10.024-0.728,10.024 c-0.671,3.413-3.584,10.411-7.726,10.445c-30.06,0.262-63.101-9.455-71.031-16.452c-4.688-4.142-1.775-12.06,4.403-12.106 C132.312-372.135,166.787-372.386,182.579-372.5"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalker);
export default __webpack_public_path__ + "static/media/walker.dd4f9174ea0725c745efefb765729ab0.svg";
export { ForwardRef as ReactComponent };